import { cva, type VariantProps } from 'class-variance-authority'

export const buttonVariants = cva(
  'inline-flex items-center justify-center whitespace-nowrap rounded-xl text-sm font-medium transition-all duration-200 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50 touch-target backdrop-blur-sm',
  {
    variants: {
      variant: {
        primary:
          'bg-primary-500 !text-white shadow-soft hover:bg-primary-600 hover:shadow-medium active:scale-95 focus-visible:ring-primary-500',
        secondary:
          'bg-white border border-neutral-200 text-neutral-700 shadow-soft hover:bg-neutral-50 hover:shadow-medium active:scale-95',
        outline:
          'bg-transparent border border-neutral-200 text-neutral-700 hover:bg-neutral-50 hover:shadow-medium',
        ghost: 'text-neutral-600 hover:bg-neutral-100 hover:text-neutral-900',
        destructive:
          'bg-error-600 text-white shadow-soft hover:bg-error-700 hover:shadow-medium active:scale-95 focus-visible:ring-error-500',
        success:
          'bg-success-600 text-white shadow-soft hover:bg-success-700 hover:shadow-medium active:scale-95 focus-visible:ring-success-500',
      },
      size: {
        sm: 'h-8 px-3 text-xs',
        md: 'h-10 px-4 text-sm',
        lg: 'h-12 px-6 text-base',
        xl: 'h-14 px-8 text-lg',
        icon: 'h-10 w-10',
      },
    },
    defaultVariants: {
      variant: 'primary',
      size: 'md',
    },
  }
)

export type ButtonVariants = VariantProps<typeof buttonVariants>
